import { Component, OnInit } from '@angular/core';
import { AccountService } from '../shared/account/account-service';
import { Router } from '@angular/router';

@Component({
  selector: 'login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {
  public email: string = '';
  public password: string = '';

  constructor(private accountService: AccountService, private router: Router) {
  }

  ngOnInit(): void {
  }

  async login() {
    await this.accountService.login(this.email, this.password);
    this.router.navigateByUrl('/');
  }
}
